import Stages from './Stages'
import { useQuery } from '@apollo/client'
import { Input } from '@/components/ui/input'
import { CubeLoader } from '@/components/ui/cube-loader'
import getSymbolFromCurrency from 'currency-symbol-map'
import { GET_AUDIENCES } from '@/graphql/audience-queries'
import { useAudienceDataWithHypotheses } from '@/hooks/useAudiencesWithHypotheses'
import { getAllStages } from '@/utils/ad-campaigns-helpers'
import { useWizard } from '@/components/common/wizard/WizardContext'

const SmartBudget = ({ selectedObjective, availableStages, onBudgetChange, store, currency, minDailyBudget }) => {
    const { getStepContentData } = useWizard()
    const salesFunnelSetupData = getStepContentData('salesFunnelSetup') || {}
    const audienceSelectionsOld = salesFunnelSetupData.audienceSelections || {}
    const allStages = getAllStages()
    const { data: catalogueAudiencesData, loading: audiencesLoading } = useQuery(GET_AUDIENCES)
    const audiencesData = useAudienceDataWithHypotheses(catalogueAudiencesData, getStepContentData)
    const audiences = audiencesData?.Audience?.audiences || []

    if (audiencesLoading) return (
        <div className="tw:w-full tw:flex tw:items-center tw:justify-center">
            <CubeLoader size="default" />
        </div>
    )

    return (
        <div className="tw:overflow-y-auto">
            <div className="tw:p-6 tw:flex tw:flex-col tw:items-start tw:gap-4">
                {/* Total Budget Input */}
                <div className="tw:flex tw:flex-col tw:gap-2">
                    <span className="tw:text-sm tw:font-semibold">Total Campaign Budget</span>
                    <div className="tw:relative tw:w-50">
                        <span className="tw:absolute tw:left-3 tw:top-1/2 tw:transform tw:-translate-y-1/2 tw:text-sm tw:pointer-events-none">
                            {getSymbolFromCurrency(currency)}
                        </span>
                        <Input
                            type="number"
                            className="tw:h-10 tw:w-full tw:pl-8"
                            min="0"
                            step="1"
                            value={store.totalSmartBudget}
                            onChange={(e) => onBudgetChange(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <Stages
                store={store}
                currency={currency}
                allStages={allStages}
                audiences={audiences}
                minDailyBudget={minDailyBudget}
                availableStages={availableStages}
                selectedObjective={selectedObjective}
                audienceSelections={audienceSelectionsOld}
                totalBudget={parseFloat(store.totalSmartBudget)}
            />
        </div>
    )
}

export default SmartBudget
